import _ from 'lodash';
import moment from 'moment';
import doorlockFormatter from '@/components/admin/doorlocks/doorlockFormatter';

const blockResult = v => ({
  0: 'Result(None)',
  1: 'Result(Success)',
  2: 'Result(Error_Reservation)',
  3: 'Result(Error_Time)',
  4: 'Result(Error_MobileKey)',
  5: 'Result(Error_No MobieKey found)',
  6: 'Result(Error_Sequence Error)',
  7: 'Result(Error_Thumb Turn Locked)',
  8: 'Result(Error_General)',
  9: 'Result(Error_Emergency)',
  10: 'Result(Error_Blocking)',
  11: 'Result(Error_Construction)',
}[v] || `Result(Unknown - ${v})`);

const blockAuth = v => ({
  C1: 'Auth(1 MobileKey)',
  C2: 'Auth(2 MobileKey)',
  C3: 'Auth(3 Master MobileKey)',
  C4: 'Auth(4 Staff MobileKey)',
  C5: 'Auth(5 Master MobileKey)',
  C6: 'Auth(6 Staff MobileKey)',
}[v] || `Auth(Unknown - ${v})`);

const blockCardType = v => ({
  10: 'CardType(Guest card)',
  20: 'CardType(Staff Building card)',
  21: 'CardType(Staff Floor card)',
  22: 'CardType(Staff GroupA card)',
  23: 'CardType(Staff GroupB card)',
  24: 'CardType(Staff Maintenance card)',
  30: 'CardType(Master Supervisor card)',
  31: 'CardType(Master Emergency card)',
  32: 'CardType(Master Blocking card)',
  33: 'CardType(Master Opening card)',
  34: 'CardType(Master Prohibit card)',
  40: 'CardType(Room Setup card)',
  41: 'CardType(Access Setup card)',
  42: 'CardType(Common area Setup card)',
  43: 'CardType(Group Setup card)',
  44: 'CardType(BLE Setup card)',
  45: 'CardType(Date,Time Setup card)',
  46: 'CardType(Programming Setup card)',
  47: 'CardType(Touch Setup card)',
  80: 'CardType(MobileApp Setup card)',
}[v] || `CardType(Unknown - ${v})`);

const blockFWModel = v => `Model(${doorlockFormatter.fwType(v)})`;
const blockSimple = (name, value) => `${name}(${value})`;
const blockSetTime = v => moment(v).format('YYYY-MM-DD HH:mm:ss');
const blockSetTimeZone = v => blockSimple('TimeZone', v);
const blockSize = v => blockSimple('Size', v);
const blockUser = v => blockSimple('User', v);
const blockID = v => blockSimple('ID', v);
const blockFWVersion = v => blockSimple('Version', v);
const blockCMD = v => blockSimple('CMD', v);
const blockErrorCode = v => blockSimple('Code', v);
const blockCodebookID = v => blockSimple('Id', v);
const blockState = (s) => {
  const [bit3, , bit1] = s.split('');
  const bit3String = bit3 === '0' ? 'Closed' : 'Opened';
  const bit1String = bit1 === '0' ? 'UnLocked' : 'Locked';
  return `State(${s}_${bit3String}_${bit1String})`;
};
const modeString = s => `Mode(${s})`;
const blockMode = (m) => {
  const [uninstalled, opening, blocking, emergency] = m.split('');
  if (opening === '1') return modeString('Construction');
  if (blocking === '1') return modeString('Blocking');
  if (emergency === '1') return modeString('Emergency');
  if (uninstalled === '1') return modeString('Invalid Mode');
  return modeString('Normal');
};

const blockSetupResult = (v) => {
  const formated = {
    0: 'Erase',
    1: 'Write',
  }[v] || `Unknown - ${v}`;
  return `Result(${formated})`;
};
const blockRTCReset = v => (v === '1' ? 'RTC RESET' : '');

const logFormatter = {
  64: ['Booting', [blockFWVersion, blockFWModel, blockRTCReset]],
  65: ['Set Time', [blockUser, blockSetTime, blockRTCReset]],
  66: ['Set TimeZone', [blockUser, blockSetTimeZone, blockRTCReset]],
  67: ['Mobilekey Add', [blockUser, blockID, blockRTCReset]],
  68: ['Mobilekey Delete', [blockUser, blockID, blockRTCReset]],
  69: ['Mobilekey Delete All', [blockUser, blockSize, blockRTCReset]],
  70: ['Mobilekey Authorization', [blockUser, blockID, blockAuth, blockResult, blockState, blockMode, blockRTCReset]],
  71: ['Card Authorization', [blockUser, blockCardType, blockResult, blockState, blockMode, blockRTCReset]],
  72: ['Key Authorization', [blockState, blockMode, blockRTCReset]],
  75: ['Change State', [blockState, blockMode, blockRTCReset]],
  76: ['Metal Touch Detected', [blockState, blockMode, blockRTCReset]],
  77: ['Setup Card', [blockUser, blockCardType, blockSetupResult, blockState, blockMode, blockRTCReset]],
  79: ['Operation Fail', [blockCMD, blockErrorCode, blockCodebookID, blockRTCReset]],
};

const logFormatterTypeList = [
  { text: 'Booting(64)', value: 64 },
  { text: 'Set Time(65)', value: 65 },
  { text: 'Set TimeZone(66)', value: 66 },
  { text: 'Mobilekey Add(67)', value: 67 },
  { text: 'Mobilekey Delete(68)', value: 68 },
  { text: 'Mobilekey Delete All(69)', value: 69 },
  { text: 'Mobilekey Authorization(70)', value: 70 },
  { text: 'Card Authorization(71)', value: 71 },
  { text: 'Key Authorization(72)', value: 72 },
  { text: 'Change State(75)', value: 75 },
  { text: 'Metal Touch Detected(76)', value: 76 },
  { text: 'Setup Card(77)', value: 77 },
  { text: 'Operation Fail(79)', value: 79 },
];

const messageDesc = (type, message, formatter) => {
  const blocks = _.slice(_.map(message.split(','), v => v.trim()), 0, formatter.length);
  const blocks2 = _.map(blocks, (b, i) => formatter[i](b));
  return _.compact(blocks2).join(', ');
};


export default {
  formatType(type) {
    const table = logFormatter[type];
    return table ? `${table[0]}(${type})` : `*${type}`;
  },
  formatMessage(type, message) {
    const table = logFormatter[type];
    if (table) {
      const [, formatter] = table;
      return messageDesc(type, message, formatter);
    }
    return message;
  },
  formatTime(time) {
    if (moment(time).isValid()) return moment(time).format('YYYY-MM-DD HH:mm:ss');
    return `Unknown - ${time}`;
  },
  getFormatTypeList() {
    return logFormatterTypeList;
  },
};



// WEBPACK FOOTER //
// ./src/components/admin/doorlocks/doorlockLogFormatter.js